import {
  FeedstockBmpPotentialAI1,
  FeedstockBmpPotentialAI1PropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-AI1.model';
import { ValidationInterface } from '../../../validation.interface';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialAI1Validation implements ValidationInterface {
  /** The current BMP potential nutrition obj that is being validated */
  bmpPotentialAI1: FeedstockBmpPotentialAI1;

  /**
   * Sets the BMP potential nutrition obj that will be used for validation
   * @param bmpPotentialNutrition will be used to set the current BMP potential nutrition obj
   */
  constructor(bmpPotentialAI1: FeedstockBmpPotentialAI1) {
    if (!bmpPotentialAI1) throw Error('invalid BMP potential AI1 provided for validation');
    this.bmpPotentialAI1 = new FeedstockBmpPotentialAI1(bmpPotentialAI1);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential nutrition obj
   * @param validationUnit, if provided will have the validation for the current BMP potential nutrition
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialAI1) throw Error('unable to validation BMP potential');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.lipidFat).getValidation(),
      FeedstockBmpPotentialAI1PropName.lipidFat
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.protein).getValidation(),
      FeedstockBmpPotentialAI1PropName.protein
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.hemicellulose).getValidation(),
      FeedstockBmpPotentialAI1PropName.hemicellulose
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.cellulose).getValidation(),
      FeedstockBmpPotentialAI1PropName.cellulose
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.lignin).getValidation(),
      FeedstockBmpPotentialAI1PropName.lignin
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI1.nonFibreCarbohydrate).getValidation(),
      FeedstockBmpPotentialAI1PropName.nonFibreCarbohydrate
    );
    if (this.bmpPotentialAI1.ch4ContentEnabled) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.bmpPotentialAI1.ch4Content).getValidation(),
        FeedstockBmpPotentialAI1PropName.ch4Content
      );
    }

    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential AI1 obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
